import Phaser from 'phaser';
import { PowerUpDefinition } from '../data/PowerUps';
import { CAT_POWERUP, POWERUP_RADIUS } from '../config/Constants';

export class PowerUp {
  public definition: PowerUpDefinition;
  public scene: Phaser.Scene;
  public body: MatterJS.BodyType;
  public graphics: Phaser.GameObjects.Graphics;
  public collected: boolean = false;
  public spawnTime: number;
  private glowPhase: number = 0;

  constructor(scene: Phaser.Scene, x: number, y: number, definition: PowerUpDefinition) {
    this.scene = scene;
    this.definition = definition;
    this.spawnTime = Date.now();

    // Cuerpo físico (trigger de colisión)
    this.body = scene.matter.add.circle(x, y, POWERUP_RADIUS, {
      label: `powerup_${definition.id}`,
      isSensor: true,
      collisionFilter: {
        category: CAT_POWERUP,
        mask: 0xFFFF, // colisiona con todo (para detectar peonzas)
        group: 0,
      },
    });

    // Visual
    this.graphics = scene.add.graphics();
    this.draw();
  }

  draw(): void {
    this.graphics.clear();
    const x = this.body.position.x;
    const y = this.body.position.y;
    const r = POWERUP_RADIUS;
    const glow = 0.6 + Math.sin(this.glowPhase) * 0.3;

    // Glow exterior
    this.graphics.fillStyle(this.definition.color, glow * 0.3);
    this.graphics.fillCircle(x, y, r * 2);

    // Círculo principal
    this.graphics.fillStyle(this.definition.color, 0.9);
    this.graphics.fillCircle(x, y, r);

    // Borde brillante
    this.graphics.lineStyle(2, 0xffffff, glow);
    this.graphics.strokeCircle(x, y, r);
  }

  update(delta: number): void {
    this.glowPhase += delta * 0.005;
    this.draw();
  }

  destroy(): void {
    this.collected = true;
    this.graphics.destroy();
    const world = this.scene.matter.world.localWorld;
    (this.scene.matter.composite as any).remove(world, this.body);
  }
}
